import type { ReactNode } from 'react';
import './Tile.scss';
import { Icon, type IconNames } from '@petsmart-ui/sparky';
import type { DeliveryType } from '@libs/core';

type TileProps = {
    value: DeliveryType;
    selectedValue?: string;
    onChange: (value: DeliveryType) => void;
    iconName: IconNames | 'car-outline';
    title: ReactNode;
    children: ReactNode;
    isTileDisabled?: boolean;
    groupName?: string;
};

export default function Tile({
    value,
    selectedValue,
    onChange,
    title,
    children,
    iconName,
    isTileDisabled = false,
    groupName,
}: Readonly<TileProps>) {
    const isSelected = value === selectedValue;
    let stateClass = '';
    if (isTileDisabled) {
        stateClass = 'disabled';
    } else if (isSelected) {
        stateClass = 'selected';
    }

    const className = `${value} radio-card ${stateClass}`;

    return (
        <label className={className}>
            {isTileDisabled ? (
                <input type="radio" className="hidden-radio" disabled />
            ) : (
                <input
                    type="radio"
                    name={groupName}
                    value={value}
                    checked={isSelected}
                    onChange={() => onChange(value)}
                    className="hidden-radio"
                />
            )}
            {isSelected && (
                <div className="checkmark-corner">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="8"
                        viewBox="0 0 10 8"
                        fill="none"
                        className="checkmark-icon"
                    >
                        <path
                            d="M3.56756 7.3997C3.55932 7.3997 3.55116 7.3997 3.54292 7.3989C3.34564 7.39266 3.15892 7.30282 3.03044 7.15434L0.347959 4.09378C0.129559 3.84458 0.154599 3.46562 0.403799 3.2473C0.652599 3.02778 1.03196 3.05354 1.25028 3.30314L3.59292 5.97618L8.7742 0.776181C9.0078 0.541781 9.38828 0.540261 9.62268 0.774581C9.8578 1.00858 9.8578 1.38826 9.62428 1.62298L4.08164 7.18546C3.94612 7.32218 3.7598 7.3997 3.56756 7.3997ZM3.93124 6.36138L3.93556 6.36682C3.93396 6.36522 3.93284 6.3629 3.93124 6.36138ZM3.23196 6.33802C3.23156 6.33882 3.23116 6.33962 3.23036 6.33962L3.23196 6.33802Z"
                            fill="white"
                            opacity={1}
                        />
                    </svg>
                </div>
            )}
            <div className="radio-card-content">
                {iconName == 'car-outline' ? (
                    <div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="16"
                            viewBox="0 0 20 16"
                            fill="none"
                        >
                            <path
                                d="M19.7771 7.1275L18.2805 4.6971C18.0071 4.2531 17.5231 3.9827 17.0017 3.9827H15.0001V1.4971C15.0001 0.6703 14.3299 0 13.503 0H1.4971C0.6703 0.0001 0 0.6703 0 1.4972V11.5031C0 12.3299 0.6703 13.0002 1.4971 13.0002H2.0031C2.0031 14.6571 3.3462 16.0002 5.0031 16.0002C6.66 16.0002 8.0031 14.6571 8.0031 13.0002H11.0031C11.0031 14.6571 12.3462 16.0002 14.0031 16.0002C15.66 16.0002 17.0031 14.6571 17.0031 13.0002H18.4979C19.3276 13.0002 20 12.3277 20 11.4981V7.9148C20 7.6368 19.9229 7.3642 19.7771 7.1275ZM5.0031 14.5001C4.176 14.5001 3.5031 13.8272 3.5031 13.0001C3.5031 12.173 4.176 11.5001 5.0031 11.5001C5.8302 11.5001 6.5031 12.173 6.5031 13.0001C6.5031 13.8272 5.8302 14.5001 5.0031 14.5001ZM7.5878 11.5015C7.0683 10.6078 6.1113 10.0001 5.0031 10.0001C3.8949 10.0001 2.937 10.6084 2.4177 11.5028L1.5 11.503L1.4971 1.5001H13.5L13.5007 3.9828L13.5 10.0509C12.6077 10.2024 11.8578 10.7465 11.4189 11.5007L7.5878 11.5015ZM14.0031 14.5001C13.176 14.5001 12.5031 13.8272 12.5031 13.0001C12.5031 12.173 13.176 11.5001 14.0031 11.5001C14.8302 11.5001 15.5031 12.173 15.5031 13.0001C15.5031 13.8272 14.8302 14.5001 14.0031 14.5001ZM18.4979 11.5001H16.5871C16.2322 10.8904 15.6744 10.4217 15.0001 10.1828V5.4827H17.0017L17.0033 5.4836L18.5001 7.9146L18.4979 11.5001Z"
                                fill="#131313"
                                fillOpacity={1}
                            />
                        </svg>
                    </div>
                ) : (
                    <Icon
                        name={iconName}
                        className={`icon ${isTileDisabled ? 'disabled' : ''}`}
                    />
                )}
                {title}
                {children}
            </div>
        </label>
    );
}
